import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDayLimit]'
})
export class DayLimitDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(e: KeyboardEvent): void {
    let value = Number((e.target as HTMLInputElement).value);
    if (value < 1) {
      this.control.control.setValue('');
    } else if (value > 31) {
      const firstNumber = value.toString();
      value = Number(firstNumber.slice(0, 1));
      this.control.control.setValue(value.toString());
    }
  }
}
